import { render, staticRenderFns } from "./vsPagination.vue?vue&type=template&id=ae7a01a0&scoped=true&"
import script from "./vsPagination.vue?vue&type=script&lang=js&"
export * from "./vsPagination.vue?vue&type=script&lang=js&"
import style0 from "./vsPagination.vue?vue&type=style&index=0&id=ae7a01a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7a01a0",
  null
  
)

export default component.exports